import React, { useRef, useState } from "react";
import Cropper from "react-cropper";

import { Dialog } from "@headlessui/react";

import Button from "../Button";

import "cropperjs/dist/cropper.css";
import "./style.css";

export const ImageCropper = (props) => {
  const { thumb, aspectRatio = 1, rectangular = false, caption, onRemove } = props;

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [croppedFilePath, setCroppedFilePath] = useState(null);
  const [croppedFile, setCroppedFile] = useState(null);
  const cropper = useRef(null);
  const fileInputRef = useRef(null);

  const handleClose = () => {
    if (fileInputRef && fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setOpenDialog(false);
  };

  const fileSelectHandler = async (event) => {
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const newFile = Object.assign(file, {
        preview: URL.createObjectURL(file),
      });

      setSelectedFile(newFile);
      setOpenDialog(true);
    }
  };

  const onCrop = () => {
    const str = cropper.current.cropper
      .getCroppedCanvas({
        width: 1280,
        height: 720,
      })
      .toDataURL(selectedFile.type, 1);

    setCroppedFilePath(str);
    base64StringtoFile(str, selectedFile.name, "image/jpeg").then((file) => {
      setCroppedFile(file);
    });
  };

  function base64StringtoFile(url, filename, mimeType) {
    if (url.startsWith("data:")) {
      var arr = url.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let file = new File([u8arr], filename, { type: mime || mimeType });
      return Promise.resolve(file);
    }
    return fetch(url)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], filename, { type: mimeType }));
  }

  const confirmCroppedImage = async () => {
    onFileSubmit().then(() => {
      handleClose();
    });
  };

  async function onFileSubmit(e) {
    if (props.onFileSubmit) props.onFileSubmit(selectedFile, croppedFile, thumb);
  }

  if (rectangular) {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
          {caption && (
            <div style={{ 
              fontSize: "0.8rem", 
              color: "#999", 
              marginBottom: 4,
              fontWeight: "bold"
            }}>
              {caption}
            </div>
          )}
          <div style={{ 
            width: 200, 
            height: 40, // Match text field height
            border: thumb ? 'none' : '1px dashed #ccc',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {thumb ? (
              <img 
                src={thumb} 
                alt="Uploaded" 
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'contain',
                  borderRadius: 6
                }} 
              />
            ) : (
              <div style={{ 
                textAlign: 'center', 
                color: '#666',
                fontSize: 14
              }}>
                Upload logo
              </div>
            )}
            <input 
              ref={fileInputRef} 
              type="file" 
              accept="image/png, image/jpeg, image/gif" 
              onChange={fileSelectHandler} 
              style={{ 
                position: 'absolute', 
                top: 0, 
                left: 0, 
                width: '100%', 
                height: '100%', 
                opacity: 0, 
                cursor: 'pointer' 
              }} 
            />
          </div>
          {thumb && onRemove && (
            <button 
              onClick={onRemove}
              style={{
                fontSize: 12,
                background: 'none',
                border: 'none',
                color: '#999',
                cursor: 'pointer',
                marginTop: 4,
                textDecoration: 'underline'
              }}
            >
              Remove
            </button>
          )}
        </div>
        <Dialog as="div" className="dialog" open={openDialog} onClose={handleClose}>
          <Dialog.Panel>
            <Dialog.Title className="title">{thumb ? <div>Change logo</div> : <div>Upload logo</div>}</Dialog.Title>
            <div style={{ display: "flex" }}>
              {selectedFile && (
                <Cropper
                  ref={cropper}
                  style={{ height: 400, marginBottom: 30 }}
                  aspectRatio={aspectRatio}
                  src={selectedFile?.preview}
                  preview=".img-preview"
                  guides={false}
                  crop={onCrop}
                  checkOrientation={false}
                  minCropBoxHeight={10}
                  minCropBoxWidth={10}
                  responsive={true}
                  autoCrop={1}
                />
              )}
            </div>

            <Button text="Confirm cropping" callback={confirmCroppedImage} large color="black" />
            <br />
            <Button text="Cancel" callback={handleClose} color="red" />
          </Dialog.Panel>
        </Dialog>
      </>
    );
  }

  return (
    <>
      <div className="imageContainer">
        <label className="label-image">
          {thumb ? <img src={thumb} alt="Uploaded" className="image" /> : croppedFilePath && <img src={croppedFilePath} alt="Uploaded" className="image" />}
          <div className="card">
            <input ref={fileInputRef} type="file" accept="image/png, image/jpeg, image/gif" onChange={fileSelectHandler} className="fileInput" />
            {thumb ? <span className="change-picture">Change picture</span> : <span>Upload picture</span>}
          </div>
        </label>
      </div>
      <Dialog as="div" className="dialog" open={openDialog} onClose={handleClose}>
        <Dialog.Panel>
          <Dialog.Title className="title">{thumb ? <div>Change picture</div> : <div>Upload picture</div>}</Dialog.Title>
          <div style={{ display: "flex" }}>
            {selectedFile && (
              <Cropper
                ref={cropper}
                style={{ height: 400, marginBottom: 30 }}
                aspectRatio={aspectRatio}
                src={selectedFile?.preview}
                preview=".img-preview"
                guides={false}
                crop={onCrop}
                checkOrientation={false}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                responsive={true}
                autoCrop={1}
              />
            )}
          </div>

          <Button text="Confirm cropping" callback={confirmCroppedImage} large color="black" />
          <br />
          <Button text="Cancel" callback={handleClose} color="red" />
        </Dialog.Panel>
      </Dialog>
    </>
  );
};
